import * as actions from './actions';
import reducers from './reducer';

export const Movie = { actions, reducers };
export { MovieState } from './reducer';
